import React, { memo, useState } from 'react';
import useIsMobile from '@/hooks/useIsMobile';
import ImagePickerContext from '../ImagePickerContext';
import ImageModal from '../ImagesModal';
import Desktop from './desktop';
import Mobile from './mobile';
import useComponent from './useComponent';

const MultiImagePickerContent = () => {
  const isMobile = useIsMobile(992);
  const viewModel = useComponent();

  return (
    <>
      {isMobile ? <Mobile viewModel={viewModel} /> : <Desktop viewModel={viewModel} />}
      <ImageModal open={viewModel.isModalOpen} onOk={viewModel.handleLibraryOk} onCancel={viewModel.handleLibraryCancel} />
    </>
  );
};

const MultiImagePicker = ({ value, maxPhotos = 10, acceptedFormats = ['image/jpeg', 'image/png', 'image/webp'], maxFileSize = 10485760, onChange }) => {
  const [folder, setFolder] = useState();

  return (
    <ImagePickerContext.Provider value={{ value, maxPhotos, acceptedFormats, maxFileSize, onChange, folder, setFolder }}>
      <MultiImagePickerContent />
    </ImagePickerContext.Provider>
  );
};

export default memo(MultiImagePicker);